var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareArrowUpSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.36438,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#002C38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07063 14.0931L12.3901 8.99637C12.5429 8.84606 12.7099 8.75977 12.8769 8.75977C13.0439 8.75977 13.2101 8.82153 13.3387 8.94593L18.6582 14.0427C18.9252 14.2975 18.9339 14.7202 18.6782 14.9863C18.4242 15.2543 17.9995 15.263 17.7343 15.0063L12.8769 10.377L7.9945 15.0535C7.73006 15.3101 7.30473 15.3014 7.05058 15.0335C6.79483 14.7696 6.80351 14.3464 7.07063 14.0931Z",
    fill: "#B3C0C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.36438,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#B3C0C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrowUpSmall);
export default __webpack_public_path__ + "static/media/share-arrow-up-small.1cc0666b2872268628ec5314bc2438e6.svg";
export { ForwardRef as ReactComponent };